import React, { useState } from 'react'
import Layout from "../../shared/components/organisms/layout/layout";
import SEO from "../../shared/seo";
import useMediaQuery from '../../shared/utils/useMediaQuery';
import PrizeItemContent from "../organisms/prize-item-content/prize-item-content";

const PrizeItemTemplate = props => {
    const prize = props.pageContext.params;

    // send active modal to layout
    const [modalActive, setModalActive] = useState();

    const isMobile = useMediaQuery()
    // var news_info=props.dataProp

    // send active modal to layout

    return (
        <Layout
            mobile={isMobile}
            modalActive={modalActive}
        >
            <SEO
                title="Mis puntos"
                url={"/mis-puntos/que-puedo-ganar/" + prize.slug}
            />

            <PrizeItemContent
                mobile={isMobile}
                prize={prize}
                setModalActive={setModalActive}
            />

        </Layout>
    )
}

export default PrizeItemTemplate;
